import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import CartItemDecoCard from '../../helpers/CartItemDecoCard';
import { numberWithCommas2, roundedPrice } from '../../helpers/product';
import { getCartItemTotal } from '../../util/helper';
import { useProductPriceToShow } from './state/useProductPriceToShow';

const DecoCardContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

function KitItemLine({
  cartItem,
  row,
  usePointsAsCurrency,
  productSettings,
  currency,
  decimalsToShow,
  artworkList,
  decoTypeList,
  isKitProduct,
  user = null,
  itemPriceDisplay,
  priceDisplay,
}) {
  const { getPointsValue } = useProductPriceToShow({ productSettings });
  const display = !cartItem.product.isKitEnabled || cartItem.product.kitPriceMode !== 'rollup';
  const price = getCartItemTotal(
    cartItem,
    artworkList,
    productSettings,
    0,
    display,
    user,
    itemPriceDisplay,
    priceDisplay,
  );
  const showPrice =
    (cartItem.product.isKitEnabled && price > 0 && cartItem.product.kitPriceMode !== 'rollup') ||
    (cartItem.isKitChildProduct && cartItem.kitPriceMode === 'separate');

  const showColor =
    typeof cartItem?.product?.showColorProd === 'boolean'
      ? cartItem?.product?.showColorProd
      : productSettings?.showColor;
  const showSize =
    typeof cartItem?.product?.showSizeProd === 'boolean'
      ? cartItem?.product?.showSizeProd
      : productSettings?.showSize;
  return (
    <Grid container spacing={8} alignItems="center">
      <Grid
        item
        container
        size={{ xs: 2 }}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {!!row.image && (
          <img
            className="img-fluid"
            style={{ maxWidth: '96px' }}
            src={row.image}
            alt={cartItem.product.productName}
            loading="lazy"
          />
        )}
      </Grid>
      <Grid item size={{ xs: 12 }}>
        <Typography variant={isKitProduct ? 'h6' : 'body1'}>
          {cartItem.product.productName}
        </Typography>
        {showColor && (
          <Typography variant={isKitProduct ? 'body1' : 'body2'}>Color: {row.color}</Typography>
        )}
        {showSize && (
          <Typography variant={isKitProduct ? 'body1' : 'body2'}>Size: {row.size}</Typography>
        )}
        {(!isKitProduct || cartItem.product.kitChangeQuantity) && (
          <Typography variant={isKitProduct ? 'body1' : 'body2'}>
            Quantity: {row.quantity}
          </Typography>
        )}
      </Grid>
      <Grid item size={{ xs: 12 }}>
        <DecoCardContainer>
          {row.decorations.map((decoration, key) => (
            <CartItemDecoCard
              key={key}
              decoration={decoration}
              artworkList={artworkList}
              decoTypeList={decoTypeList}
            />
          ))}
        </DecoCardContainer>
      </Grid>
      <Grid
        item
        container
        size={{ xs: 2 }}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {showPrice && (
          <Grid item size={{ xs: 12 }}>
            {usePointsAsCurrency ? (
              getPointsValue(price)
            ) : (
              <Typography variant={'body1'}>
                {`${currency?.currencySymbol}
                                            ${
                                              productSettings?.priceRoundUp
                                                ? roundedPrice(price, decimalsToShow)
                                                : numberWithCommas2(price, decimalsToShow)
                                            }
                                                `}
              </Typography>
            )}
          </Grid>
        )}
        {!showPrice && !isKitProduct && (
          <Grid item size={{ xs: 12 }}>
            <Typography variant={isKitProduct ? 'h6' : 'body1'}>-</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default KitItemLine;
